import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
    linkTargets,
    linkSizes,
    linkStyleTypes,
    displayTypes,
    requiredIf
} from "core/props";

import { LinkElement } from "./styles";

const UnstyledLink = ({
    children,
    className,
    size = "md",
    styleType = "primary",
    isButton = false,
    href,
    target = "_self",
    onClick,
    darkMode = false,
    disableVisitedStyle = false,
    display = "inline-block",
    isDisabled = false,
    ...otherProps
}) => {
    const handleClick = e => {
        onClick && onClick(e);
    };

    const conditionalProps = isButton
        ? {
              onClick: handleClick
          }
        : { href, target, onClick: handleClick };

    return (
        <LinkElement
            className={className}
            size={size}
            styleType={styleType}
            as={isButton ? "button" : "a"}
            isButton={isButton}
            darkMode={darkMode}
            disableVisitedStyle={disableVisitedStyle}
            display={display}
            aria-disabled={isDisabled}
            {...otherProps}
            {...conditionalProps}
        >
            {children}
        </LinkElement>
    );
};

const Link = styled(UnstyledLink)``;

Link.propTypes = {
    size: PropTypes.oneOf(linkSizes),
    styleType: PropTypes.oneOf(linkStyleTypes),
    isButton: PropTypes.bool,
    onClick: requiredIf({
        type: PropTypes.func,
        condition: props => props.isButton === true
    }),
    href: requiredIf({
        type: PropTypes.string,
        condition: props => props.isButton === false
    }),
    target: PropTypes.oneOf(linkTargets),
    darkMode: PropTypes.bool,
    disableVisitedStyle: PropTypes.bool,
    display: PropTypes.oneOf(displayTypes),
    isDisabled: PropTypes.bool
};

export default Link;
